export const ImageToPdf = (
  blob: Blob,
  image_resolution: number
): Promise<Blob> =>
  import("../utils/Proxy").then(({ ImageToPdf }) =>
    ImageToPdf(blob, image_resolution)
  )
